import React from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import parse from "html-react-parser"
import Typography from "aldoo-ra/Typography"
import Button from "aldoo-ra/Button"
import PlatformsAvailable from "../PlatformsAvailable"
import SitePlatform from "../SitePlatform"
import DynamicSVG from "aldoo-ra/DynamicSVG"

const HeaderSectionLeft = () => {
  const { platform } = SitePlatform()
  return (
    <CMSRender
      contentType="PageSectionHeader"
      match={{ "content.name": "FeaturesHeaderLeft" }}
      renderItem={(data, id) => {
        const button = data.button?.find(
          (item) => item.options?.platform === platform
        ) || data.button?.[0] // Fallback to first button if no platform match
        return (
          <div
            key={id}
            className="flex flex-col w-full lg:w-1/2 lg:min-h-[570px] items-center lg:items-start justify-start gap-5" // Review min-w after font substiution with Proxima Nova
          >
            {/* Image */}
            <div>
              <img
                src={data.image}
                alt="Oxford Dictionary Logo"
                className="w-[90px] h-[90px]"
              />
            </div>

            {/* Title */}
            <Typography
              variant="h1"
              className="text-center lg:text-left text-text"
            >
              {data.title && typeof data.title === 'string' ? parse(data.title) : data.title}
            </Typography>

            {/* Paragraph */}
            <Typography
              variant="body1"
              className="max-w-[520px] xl:max-w-[580px] text-center lg:text-left my-0"
            >
              {data.text}
            </Typography>

            {/* CTA Button */}
            {button && (
              <Button variant="primary_xl">
                <DynamicSVG
                  className="w-6"
                  url={button.image}
                  alt="Platform Logo"
                />

                <a href={button.link?.[0]?.url} target="_blank">
                  {button.label}
                </a>
              </Button>
            )}

            {/* Platforms Available */}
            <PlatformsAvailable
              selectedPlatform={platform}
              variant="centered"
              data={data}
            />
          </div>
        )
      }}
    />
  )
}

export default HeaderSectionLeft
